export default __webpack_public_path__ + "static/media/peopleSearch.c67c2ec8.png";